<template>
  <div class="content">
    <van-form @submit="onSubmit">
      <div class="upload plc">
            <div class="upload_content">
                <span style="font-size: 14px">请您自拍一张头像</span>
                <van-uploader v-model="file" :max-count="1" :after-read="afterRead" />      
            </div>
            <div class="upload_errmsg" v-show="isPic">请上传头像!</div>
      </div>
      <van-field v-model="subForm.name" label="姓名" placeholder="请填写" :rules="[{ required: true, message: '请填写姓名！' }]"/>
      <div class="sex plc plcgo">
            <van-field
                readonly
                clickable
                name="picker"
                :value="form.sex"
                label="性别"
                placeholder="请选择"
                @click="showPicker = true"
                :rules="[{ required: true, message: '请选择性别！' }]"
            />
            <van-popup v-model="showPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
                />
            </van-popup>
            <img :src="require('@/assets/img/go.png')" alt="">
      </div>
      <div class="birthday plc plcgo">
            <van-field
                readonly
                clickable
                name="picker"
                :value="form.birthday"
                label="出生日期"
                placeholder="请选择"
                @click="datepicker = true"
                :rules="[{ required: true, message: '请选择出生日期！' }]"
            />
            <van-popup v-model="datepicker" position="bottom">
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="选择出生日期"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="choiceDate"
                    @cancel="datepicker = false"
                />
            </van-popup>
            <img :src="require('@/assets/img/go.png')" alt="">
      </div>
      <div class="nation plc plcgo">
            <van-field
                readonly
                clickable
                name="picker"
                :value="form.nation"
                label="民族"
                placeholder="请选择"
                @click="nationpicker = true"
                :rules="[{ required: true, message: '请选择民族！' }]"
            />
            <van-popup v-model="nationpicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="nationColumns"
                    @confirm="nationConfirm"
                    @cancel="nationpicker = false"
                />
            </van-popup>
            <img :src="require('@/assets/img/go.png')" alt="">
      </div>
      <div class="marry plc plcgo">
            <van-field
                readonly
                clickable
                name="picker"
                :value="form.marry_status"
                label="婚姻状况"
                placeholder="请选择"
                @click="marrypicker = true"
                :rules="[{ required: true, message: '请选择婚姻状况！' }]"
            />
            <van-popup v-model="marrypicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="marryColumns"
                    @confirm="marryConfirm"
                    @cancel="marrypicker = false"
                />
            </van-popup>
            <img :src="require('@/assets/img/go.png')" alt="">
      </div>
      <div class="education plc plcgo">
            <van-field
                readonly
                clickable
                name="picker"
                :value="form.education"
                label="最高学历"
                placeholder="请选择"
                @click="edupicker = true"
                :rules="[{ required: true, message: '请选择学历！' }]"
            />
            <van-popup v-model="edupicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="eduColumns"
                    @confirm="eduConfirm"
                    @cancel="edupicker = false"
                />
            </van-popup>
            <img :src="require('@/assets/img/go.png')" alt="">
      </div>
      <van-field v-model="subForm.idcard" label="身份证号" placeholder="请填写" :rules="[{ validator: validator, message: '身份证格式错误' }]"/>
      <!-- <van-field v-model="subForm.idcard" label="身份证号" placeholder="请填写" :rules="[{ required: true, message: '请填写身份证号！' },{ pattern: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, message: '身份证格式错误'}]"/> -->
      <van-field v-model="subForm.census_address" label="户口所在地" placeholder="请填写" :rules="[{ required: true, message: '请填写户口所在地！' }]"/>
      <van-field v-model="subForm.address" label="现住址" placeholder="请填写" :rules="[{ required: true, message: '请填写现住址！' }]"/>
      <van-field v-model="subForm.email" label="电子邮箱" placeholder="请填写" 
            :rules="[{ required: true, message: '请填写您的邮箱！' },
              { pattern: /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/, message: '邮箱格式错误！'}
            ]"/>
      <div style="margin: 16px">
        <van-button round block type="danger" native-type="submit" ref="savebtn">下一步</van-button>
      </div>
    </van-form>
    <load :loading="loading"></load>
  </div>
</template>
<script>
import { getNationApi,getEducationApi,resumeinfoAPi,getResumeApi } from "@/api/interview";
import Load from "@/components/Loading"
import axios from 'axios'
var time=new Date();
var cyear=time.getFullYear();
var cmonth=time.getMonth();
var cday=time.getDate()
export default {
  data() {
    return {
      form: {},
      subForm:{},
      columns: [{id:0,text:"男"},{id:1,text:"女"}],
      nationColumns:[],
      marryColumns:[{id:2,text:"未婚"},{id:1,text:"已婚"}],
      eduColumns:[],
      showPicker: false, //性别
      datepicker:false, //出生日期
      nationpicker:false, //民族
      marrypicker:false, //婚姻
      edupicker:false, //学历
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2125, 10, 1),
      currentDate: new Date(),
      file:[],
      isPic:false,
      nation:{},
      education:{},
      loading:false,
      id:0,   //用户ID
      emp_id:''
    };
  },
  methods: {
    validator(val) {
        if(this.subForm.idcard){
            return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(val);
        }else{
            return
        }
    },
    onSubmit(values) {
        if(!this.file.length){
            this.isPic=true
            return;
        }
        const params = {
            id:this.id,
            telephone:sessionStorage.getItem("phoneNumber"),
            ...this.form,
            ...this.subForm,
            emp_id:this.emp_id
        }
        // console.log(params)
        resumeinfoAPi(params).then(res=>{
            if(res.errNo===0){
                sessionStorage.setItem('ID',res.result)
                if(this.$route.query.edit){
                    this.$router.push({path:'/interviews/resume'})
                } else {
                    this.$router.push({path:"/interviews/jobinfo"})
                }
            } else {
                Toast('提交失败请重试');
            }
        })
    },
    // 图片上传
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
        var formData = new FormData();
        formData.append('pic',file.file)
        axios.post('https://f.zhulong.com/uploadZhulongImgForEdit.php',formData).then(res=>{
            if(res.status===200){
                this.subForm.avatar_url = res.data.url
            }
        })
    },
    // 性别选择器
    onConfirm(value){
        this.form.sex = value.text;
        this.subForm.sex = value.id;
        this.showPicker = false;
    },
    // 日期选择器
    choiceDate(value){
        let year = value.getFullYear();
        let month = value.getMonth() + 1 < 10 ? '0' + (value.getMonth() + 1) :value.getMonth() + 1;
        let day = value.getDate() < 10 ? '0' + value.getDate() : value.getDate();
        this.form.birthday = year + '-' + month + '-' + day
        this.subForm.birthday = year + '-' + month + '-' + day
        this.datepicker = false
    },
    // 民族选择器
    nationConfirm(value){
        this.form.nation  = value.text
        this.subForm.nation = value.id
        this.nationpicker = false
    },
    // 婚姻选择器
    marryConfirm(value){
        this.form.marry_status  = value.text
        this.subForm.marry_status = value.id
        this.marrypicker = false
    },
    // 学历选择器
    eduConfirm(value){
        this.form.education  = value.text
        this.subForm.education = value.id
        this.edupicker = false
    },
    async getData(id){
        let result = {}
        if(id!=0){
            const res = await getResumeApi({id})
            result = res.result
            if(result.avatar_url){
                this.file.push({
                    url:result.avatar_url
                })
            }
        }
        let temform = {
            ...result,
            sex:id!=0 ? result.sex==0 ? '男' :"女" :'',
            marry_status:id!=0 ? result.marry_status==1 ?"已婚":"未婚" :'',
        }
        this.subForm = {...result}
        //  获取民族信息
        await getNationApi().then(res=>{
            if(res.errNo===0){
                this.nation = res.result
                temform.nation=res.result[temform.nation]
                for(let key in res.result){
                    this.nationColumns.push({
                        id:key,
                        text:res.result[key]
                    })
                }
            }
        })

        // 获取学历
        await getEducationApi().then(res=>{
            if(res.errNo===0){
                this.education = res.result
                temform.education=res.result[temform.education]
                for(let key in res.result){
                    this.eduColumns.push({
                        id:key,
                        text:res.result[key]
                    })
                }
            }
        })
        this.form = temform
        this.loading = false
    }
  },
  created(){
    const id = sessionStorage.getItem('ID') || 0
    this.id = id
    if(id){
        this.loading = true
    }
    this.getData(id)
  },
  mounted() {
    this.emp_id = this.$route.query.emp_id
    if(this.$route.query.edit){
        this.$refs['savebtn'].innerHTML="保存"
    }
  },
  components: {
      Load
  }
};
</script>

<style scoped lang="less">
.upload {
  padding: 39px 30px 10px;
    position: relative;
        .upload_content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            color: #999999;
            // font-size: 28px;
        }
    }
    .upload_errmsg{
        text-align: center;
        color: #ee0a24;
    }
}
/deep/ .van-uploader__upload {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
/deep/ .van-cell {
  display: block;
}
/deep/ .van-field__error-message {
  text-align: center;
}
/deep/ .van-cell::after {
  border-bottom: 1px solid #999999;
}
.plc {
    position: relative;
    &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 30px;
    bottom: 0;
    left: 30px;
    border-bottom: 1px solid #999999;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

.plcgo {
    img {
        width: 18px;
        height: 31px;
        position: absolute;
        right: 30px;
        top: 54px;
    }
}
/deep/ .van-image{
    width: 100px;
    height: 100px;
    img{
        border-radius: 50%;
    }
}
/deep/ .van-button--block {
  border-radius: 10px;
}
</style>
